<div class="rightComp">
  <div class="col-12 progressTracker" *ngIf="finesDetail && finesDetail.length > 0">
    <div class="trackerTitle mb-3" [ngClass]="isArabic ? 'rightAlign' : ''">
      <span *ngIf="!isArabic">Submitted Fines : </span>
      <span *ngIf="isArabic">الغرامات المقدمة:</span>
    </div>

    <table class="table table-striped table-bordered customTable" *ngIf="!isArabic">
      <thead>
        <tr>
          <th>Assessment Name</th>
          <th>Action</th>
          <th>Violation</th>
          <th class="midAlign">1st Warning Fine</th>
          <th class="midAlign">2nd Warning Fine</th>
          <th class="midAlign">3rd Warning Fine</th>
          <th class="midAlign">Overall Status</th>
          <th class="midAlign">#</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of finesDetail; let i = index">
          <td>{{ item.mde_InspectionPlan?.mde_AssessmentUnit?.name }}</td>
          <td>{{ item.mde_InspectionPlan?.mde_name }}</td>
          <td>{{ item.mde_Violation?.mde_name }}</td>
          <td class="midAlign">{{ item.mde_Violation?.mde_1stwarningfines }}</td>
          <td class="midAlign">{{ item.mde_Violation?.mde_2ndwarningremediationtimeframefines }}</td>
          <td class="midAlign">{{ item.mde_Violation?.mde_3rdwarningandsuspensionperiodfines }}</td>
         <td class="midAlign">{{ 
              item.mde_enforcementstatus === 755020000 ? 'Active' : 
              item.mde_enforcementstatus === 755020001 ? 'Closed' : 
              item.mde_enforcementstatus === 755020002 ? 'Cancelled' : 
              item.mde_enforcementstatus === 755020003 ? 'Draft' : 
              item.mde_enforcementstatus === 755020004 ? 'Paid' : 
              item.mde_enforcementstatus === 755020005 ? 'Partially Paid' : 
              item.mde_enforcementstatus === 755020006 ? 'Void' : 
              '' 
            }}</td>
          <td class="midAlign">
            <button (click)="goToDetail(item.mde_enforcementid)"
             class="showTxt">
              View
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Arabic Table -->
    <table class="table table-striped table-bordered customTable" *ngIf="isArabic">
      <thead>
        <tr>
          <th>اسم التقييم</th>
          <th>التفتيش</th>
          <th>الإجراء</th>
          <th>المخالفة</th>
          <th class="midAlign">غرامة التحذير 1</th>
          <th class="midAlign">غرامة التحذير 2</th>
          <th class="midAlign">غرامة التحذير 3</th>
          <th class="midAlign">الحالة العامة</th>
          <th class="midAlign">#</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of finesDetail; let i = index">
          <td>{{ item.mde_InspectionPlan?.mde_AssessmentUnit?.name }}</td>
          <td>{{ item.mde_InspectionPlan?.mde_name }}</td>
          <td>{{ item.mde_Violation?.mde_name }}</td>
          <td class="midAlign">{{ item.mde_Violation?.mde_1stwarningfines }}</td>
          <td class="midAlign">{{ item.mde_Violation?.mde_2ndwarningremediationtimeframefines }}</td>
          <td class="midAlign">{{ item.mde_Violation?.mde_3rdwarningandsuspensionperiodfines }}</td>
         <td class="midAlign">{{ 
              item.mde_enforcementstatus === 755020000 ? 'Active' : 
              item.mde_enforcementstatus === 755020001 ? 'Closed' : 
              item.mde_enforcementstatus === 755020002 ? 'Cancelled' : 
              item.mde_enforcementstatus === 755020003 ? 'Draft' : 
              item.mde_enforcementstatus === 755020004 ? 'Paid' : 
              item.mde_enforcementstatus === 755020005 ? 'Partially Paid' : 
              item.mde_enforcementstatus === 755020006 ? 'Void' : 
              '' 
            }}</td>
          <td class="midAlign">
            <button (click)="goToDetail(item.mde_enforcementid)"
             class="showTxt">
              View
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
   <div *ngIf="!finesDetail || finesDetail.length === 0">
      <span *ngIf="!isArabic">No fines history found.</span>
      <span *ngIf="isArabic">لم يتم العثور على سجل للغرامات السابقة.</span>
    </div>
</div>
